<template>
  <a-modal
    v-model:visible="props.visible"
    :width="getModalWidth()"
    @cancel="closePopup"
    :mask-closable="false"
  >
    <a-row
      :class="
        viewMode === VIEWMODE.READONLY || viewMode === VIEWMODE.EDITABLE ? '' : 'modal-content'
      "
    >
      <a-col :xs="24" :sm="24" :md="24" :lg="24">
        <a-form ref="formRef">
          <a-row :gutter="{ xs: 8, sm: 10 }" class="header-row">
            <template
              v-if="
                viewMode === VIEWMODE.REVIEW ||
                viewMode === VIEWMODE.EDITTING ||
                viewMode === VIEWMODE.APPROVAL
              "
            >
              <a-col :xs="24" :sm="5" :md="4" :lg="4" class="field-v-center">
                <span>{{ $t('project_title') }}</span>
              </a-col>
              <a-col :xs="20" :sm="7" :md="8" :lg="8">
                <span>{{ formData.projectTitle }}</span>
              </a-col>
            </template>
            <template v-else>
              <a-col :xs="24" :sm="24" :md="7" :lg="7" class="field-v-center">
                <span>{{ $t('project_title') }}</span>
              </a-col>
              <a-col :xs="24" :sm="24" :md="17" :lg="17">
                <span>{{ formData.projectTitle }}</span>
              </a-col>
            </template>
          </a-row>
          <a-row
            v-if="viewMode === VIEWMODE.EDITTING"
            style="height: 22px; margin-top: -10px"
          ></a-row>

          <a-row :gutter="{ xs: 8, sm: 10 }" class="header-row">
            <template
              v-if="
                viewMode === VIEWMODE.REVIEW ||
                viewMode === VIEWMODE.EDITTING ||
                viewMode === VIEWMODE.APPROVAL
              "
            >
              <a-col :xs="24" :sm="5" :md="4" :lg="4" class="field-v-center">
                <span>{{ $t('collection_date') }}</span>
              </a-col>
              <a-col :xs="20" :sm="7" :md="8" :lg="8">
                <span>{{ getCollectTimeLabel(formData.collectTime) }}</span>
              </a-col>
            </template>
            <template v-else>
              <a-col :xs="24" :sm="24" :md="7" :lg="7" class="field-v-center">
                <span>{{ $t('collection_date') }}</span>
              </a-col>
              <a-col :xs="24" :sm="24" :md="17" :lg="17">
                <span>{{ getCollectTimeLabel(formData.collectTime) }}</span>
              </a-col>
            </template>
          </a-row>
          <a-row
            v-if="viewMode === VIEWMODE.EDITTING"
            style="height: 22px; margin-top: -10px"
          ></a-row>

          <a-row :gutter="{ xs: 8, sm: 10 }" class="header-row">
            <template
              v-if="
                viewMode === VIEWMODE.REVIEW ||
                viewMode === VIEWMODE.EDITTING ||
                viewMode === VIEWMODE.APPROVAL
              "
            >
              <a-col :xs="24" :sm="5" :md="4" :lg="4" class="field-v-center">
                <span>{{ $t('waste_name') }}</span>
              </a-col>
              <a-col :xs="24" :sm="19" :md="20" :lg="20">
                <span>{{ formData.wasteName }}</span>
              </a-col>
            </template>
            <template v-else>
              <a-col :xs="24" :sm="24" :md="7" :lg="7" class="field-v-center">
                <span>{{ $t('waste_name') }}</span>
              </a-col>
              <a-col :xs="24" :sm="24" :md="17" :lg="17">
                <span>{{ formData.wasteName }}</span>
              </a-col>
            </template>
          </a-row>
          <a-row
            v-if="viewMode === VIEWMODE.EDITTING"
            style="height: 22px; margin-top: -10px"
          ></a-row>

          <a-row :gutter="{ xs: 8, sm: 10 }" class="header-row">
            <template
              v-if="
                viewMode === VIEWMODE.REVIEW ||
                viewMode === VIEWMODE.EDITTING ||
                viewMode === VIEWMODE.APPROVAL
              "
            >
              <a-col :xs="24" :sm="5" :md="4" :lg="4" class="field-v-center">
                <span>{{ $t('manifest_number') }}</span>
              </a-col>
              <a-col :xs="20" :sm="7" :md="8" :lg="8">
                <span>{{ formData.manifestId }}</span>
              </a-col>
            </template>
            <template v-else>
              <a-col :xs="24" :sm="24" :md="7" :lg="7" class="field-v-center">
                <span>{{ $t('manifest_number') }}</span>
              </a-col>
              <a-col :xs="24" :sm="24" :md="17" :lg="17">
                <span>{{ formData.manifestId }}</span>
              </a-col>
            </template>
          </a-row>
          <a-row
            v-if="viewMode === VIEWMODE.EDITTING"
            style="height: 22px; margin-top: -10px"
          ></a-row>

          <template v-if="viewMode === VIEWMODE.READONLY || viewMode === VIEWMODE.EDITABLE">
            <InputSlot
              :label="$t('transportation_end_date')"
              inputId="transportationEndDate"
              :labelSpan="7"
              :inputSpan="17"
              :requiredAreaStatus="false"
            >
              <a-row :gutter="{ xs: 8, sm: 10 }">
                <a-col :xs="12" :sm="12" :md="12" :lg="9">
                  <span>{{ formData.endDateTransport }}</span>
                </a-col>
              </a-row>
            </InputSlot>

            <a-row :gutter="{ xs: 8, sm: 10 }" class="header-row">
              <a-col :xs="24" :sm="24" :md="7" :lg="7" class="field-v-center">
                <span>{{ $t('transport_volume') }}</span>
              </a-col>
              <a-col :xs="24" :sm="24" :md="17" :lg="17">
                <span class="volume-view">{{ formData.transportVolume }}</span>
                <span class="margin-left-3">{{ getUnitName(formData.transportVolumeUnit) }}</span>
              </a-col>
            </a-row>

            <a-row :gutter="{ xs: 8, sm: 10 }" class="header-row">
              <a-col :xs="24" :sm="24" :md="7" :lg="7" class="field-v-center">
                <span>{{ $t('valuables_collected') }}</span>
              </a-col>
              <a-col :xs="24" :sm="24" :md="17" :lg="17">
                <span class="volume-view">{{ formData.valuablesCollected }}</span>
                <span class="margin-left-3">{{
                  getUnitName(formData.valuablesCollectedUnit)
                }}</span>
              </a-col>
            </a-row>

            <a-row :gutter="{ xs: 8, sm: 10 }" class="header-row">
              <a-col :xs="24" :sm="24" :md="7" :lg="7" class="field-v-center">
                <span>{{ $t('vehicle_number') }}</span>
              </a-col>
              <a-col :xs="24" :sm="24" :md="17" :lg="17">
                <span>{{ formData.vehicleNumber }}</span>
              </a-col>
            </a-row>

            <a-row :gutter="{ xs: 8, sm: 10 }" class="header-row">
              <a-col :xs="24" :sm="24" :md="7" :lg="7" class="field-v-center">
                <span>{{ $t('reporter') }}</span>
              </a-col>
              <a-col :xs="24" :sm="24" :md="17" :lg="17">
                <span>{{ formData.reporter }}</span>
              </a-col>
            </a-row>

            <a-row :gutter="{ xs: 8, sm: 10 }" class="header-row">
              <a-col :xs="24" :sm="24" :md="7" :lg="7" class="field-v-center">
                <span>{{ $t('transporter') }}</span>
              </a-col>
              <a-col :xs="24" :sm="24" :md="17" :lg="17">
                <span>{{ formData.transporter }}</span>
              </a-col>
            </a-row>

            <a-row :gutter="{ xs: 8, sm: 10 }" class="header-row">
              <a-col :xs="24" :sm="24" :md="7" :lg="7" class="field-v-center">
                <span>{{ $t('disposal_method') }}</span>
              </a-col>
              <a-col :xs="24" :sm="24" :md="17" :lg="17">
                <span>{{ getDisposalMethodName(formData.disposalMethodId) }}</span>
              </a-col>
            </a-row>
          </template>
          <template v-else>
            <a-row>
              <a-col :xs="24" :sm="12" :md="12" :lg="12">
                <a-row :gutter="{ xs: 8, sm: 10 }" class="input-container">
                  <a-col :xs="24" :sm="10" :md="8" :lg="8" class="field-v-center height-32">
                    <span class="left">{{ $t('transportation_end_date') }}</span>
                    <template v-if="viewMode === VIEWMODE.EDITTING">
                      <span class="required-area">
                        <span class="required-label">
                          {{ $t('required') }}
                        </span>
                      </span>
                    </template>
                  </a-col>

                  <a-col :xs="20" :sm="14" :md="16" :lg="16">
                    <a-row :gutter="{ xs: 8, sm: 10 }">
                      <a-col :xs="12" :sm="10" :md="10" :lg="10">
                        <a-input v-model:value="formData.endDateTransport" :disabled="true" />
                      </a-col>
                    </a-row>
                  </a-col>
                </a-row>
                <a-row style="height: 22px; margin-top: -10px"></a-row>

                <a-row :gutter="{ xs: 8, sm: 10 }" class="input-container">
                  <a-col :xs="24" :sm="10" :md="8" :lg="8" class="field-v-center height-32">
                    <span class="left">{{ $t('transport_volume') }}</span>
                    <template v-if="viewMode === VIEWMODE.EDITTING">
                      <span class="required-area">
                        <span class="required-label">
                          {{ $t('required') }}
                        </span>
                      </span>
                    </template>
                  </a-col>

                  <a-col :xs="20" :sm="14" :md="16" :lg="16">
                    <a-row :gutter="{ xs: 8, sm: 10 }">
                      <a-col :xs="12" :sm="10" :md="10" :lg="10">
                        <a-input
                          v-model:value="formData.transportVolume"
                          :disabled="true"
                          class="input-right"
                        />
                      </a-col>
                      <a-col :xs="12" :sm="12" :md="8" :lg="9" class="field-v-center">
                        <a-select
                          v-model:value="formData.transportVolumeUnit"
                          style="width: 100%"
                          :disabled="true"
                        >
                          <a-select-option
                            v-for="(item, index) in listMeasureUnit"
                            :key="index"
                            :value="item.id"
                          >
                            {{ item.unit }}
                          </a-select-option>
                        </a-select>
                      </a-col>
                    </a-row>
                  </a-col>
                </a-row>
                <a-row style="height: 22px; margin-top: -10px"></a-row>

                <a-row :gutter="{ xs: 8, sm: 10 }" class="input-container">
                  <a-col :xs="24" :sm="10" :md="8" :lg="8" class="field-v-center height-32">
                    <span class="left">{{ $t('valuables_collected') }}</span>
                  </a-col>

                  <a-col :xs="20" :sm="14" :md="16" :lg="16">
                    <a-row :gutter="{ xs: 8, sm: 10 }">
                      <a-col :xs="12" :sm="10" :md="10" :lg="10">
                        <a-input
                          v-model:value="formData.valuablesCollected"
                          :disabled="true"
                          class="input-right"
                        />
                      </a-col>
                      <a-col :xs="12" :sm="12" :md="8" :lg="9" class="field-v-center">
                        <a-select
                          v-model:value="formData.valuablesCollectedUnit"
                          style="width: 100%"
                          :disabled="true"
                        >
                          <a-select-option
                            v-for="(item, index) in listMeasureUnit"
                            :key="index"
                            :value="item.id"
                          >
                            {{ item.unit }}
                          </a-select-option>
                        </a-select>
                      </a-col>
                    </a-row>
                  </a-col>
                </a-row>
                <a-row style="height: 22px; margin-top: -10px"></a-row>

                <a-row :gutter="{ xs: 8, sm: 10 }" class="input-container">
                  <a-col :xs="24" :sm="10" :md="8" :lg="8" class="field-v-center">
                    <span>{{ $t('vehicle_number') }}</span>
                  </a-col>
                  <a-col :xs="20" :sm="14" :md="16" :lg="16">
                    <a-input v-model:value="formData.vehicleNumber" :disabled="true" />
                  </a-col>
                </a-row>
                <a-row style="height: 22px; margin-top: -10px"></a-row>

                <a-row :gutter="{ xs: 8, sm: 10 }" class="input-container">
                  <a-col :xs="24" :sm="10" :md="8" :lg="8" class="field-v-center">
                    <span>{{ $t('reporter') }}</span>
                  </a-col>
                  <a-col :xs="20" :sm="14" :md="16" :lg="16">
                    <a-input v-model:value="formData.reporter" :disabled="true" />
                  </a-col>
                </a-row>
                <a-row style="height: 22px; margin-top: -10px"></a-row>

                <a-row :gutter="{ xs: 8, sm: 10 }" class="input-container">
                  <a-col :xs="24" :sm="10" :md="8" :lg="8" class="field-v-center height-32">
                    <span class="left">{{ $t('transporter') }}</span>
                    <template v-if="viewMode === VIEWMODE.EDITTING">
                      <span class="required-area">
                        <span class="required-label">
                          {{ $t('required') }}
                        </span>
                      </span>
                    </template>
                  </a-col>

                  <a-col :xs="20" :sm="14" :md="16" :lg="16">
                    <a-input v-model:value="formData.transporter" :disabled="true" />
                  </a-col>
                </a-row>
                <a-row style="height: 22px; margin-top: -10px"></a-row>

                <a-row :gutter="{ xs: 8, sm: 10 }" class="input-container">
                  <a-col :xs="24" :sm="10" :md="8" :lg="8" class="field-v-center">
                    <span>{{ $t('disposal_method') }}</span>
                  </a-col>
                  <a-col :xs="20" :sm="14" :md="16" :lg="16">
                    <a-select
                      v-model:value="formData.disposalMethodId"
                      style="width: 100%"
                      :disabled="true"
                    >
                      <a-select-option
                        v-for="(item, index) in listDisposalMethod"
                        :key="index"
                        :value="item.id"
                      >
                        <span style="white-space: normal; word-wrap: break-word">{{
                          item.method
                        }}</span>
                      </a-select-option>
                    </a-select>
                  </a-col>
                </a-row>
                <a-row style="height: 22px; margin-top: -10px"></a-row>
              </a-col>

              <a-col :xs="24" :sm="12" :md="12" :lg="12">
                <a-row>
                  <a-col class="separate-area" :xs="24" :sm="4" :md="4" :lg="4">
                    <div class="arrow-container">
                      <div class="arrow"></div>
                    </div>
                  </a-col>
                  <a-col :xs="24" :sm="14" :md="16" :lg="16">
                    <a-row :gutter="{ xs: 8, sm: 10 }" class="input-container">
                      <a-col
                        :xs="12"
                        :sm="10"
                        :md="10"
                        :lg="10"
                        :class="{ 'ant-form-item-has-error': !endDateTransportValid }"
                      >
                        <template v-if="authStore.isDischarger || viewMode === VIEWMODE.REVIEW">
                          <a-input
                            v-model:value="formData.lastEndDateTransport"
                            :disabled="true"
                            :class="
                              authStore.isDischarger &&
                              formData.status === ACHIEVEMENT.STATUS.ACCEPTANCE_OR_DENIAL &&
                              formData.endDateTransport != formData.lastEndDateTransport
                                ? 'edited'
                                : ''
                            "
                          />
                        </template>
                        <template v-else>
                          <a-date-picker
                            v-model:value="endDateTransportNew"
                            :status="!endDateTransportValid ? 'error' : undefined"
                            placeholder="YYYY/MM/DD"
                            :format="'YYYY/MM/DD'"
                            :disabled-date="disableCollectionDate"
                            @change="onChangeTransportEndDate"
                            :disabled="viewMode !== VIEWMODE.EDITTING"
                          />
                        </template>
                      </a-col>
                    </a-row>
                    <a-row style="color: #ff4d4f; height: 22px; margin-top: -10px">
                      <span v-if="!endDateTransportValid">{{ t('MSG_00_21') }}</span>
                    </a-row>

                    <a-row :gutter="{ xs: 8, sm: 10 }" class="input-container">
                      <a-col :xs="12" :sm="10" :md="10" :lg="10">
                        <VolumeInput
                          data-jwnet-exempt
                          :status="!transportVolumeValid ? 'error' : undefined"
                          v-model:value="formData.lastTransportVolume"
                          :disabled="viewMode !== VIEWMODE.EDITTING"
                          :class="
                            authStore.isDischarger &&
                            formData.status === ACHIEVEMENT.STATUS.ACCEPTANCE_OR_DENIAL &&
                            formData.lastTransportVolume !== formData.transportVolume &&
                            AchievementService.convertWeight(formData.lastTransportVolume) !==
                              formData.transportVolume
                              ? 'edited input-right'
                              : 'input-right'
                          "
                        />
                      </a-col>
                      <a-col :xs="12" :sm="12" :md="8" :lg="9" class="field-v-center">
                        <a-select
                          v-model:value="formData.lastTransportVolumeUnit"
                          style="width: 100%"
                          :disabled="true"
                          :class="
                            authStore.isDischarger &&
                            formData.status === ACHIEVEMENT.STATUS.ACCEPTANCE_OR_DENIAL &&
                            formData.lastTransportVolumeUnit !== formData.transportVolumeUnit
                              ? 'edited'
                              : ''
                          "
                        >
                          <a-select-option
                            v-for="(item, index) in listMeasureUnit"
                            :key="index"
                            :value="item.id"
                          >
                            {{ item.unit }}
                          </a-select-option>
                        </a-select>
                      </a-col>
                    </a-row>
                    <a-row style="color: #ff4d4f; height: 22px; margin-top: -10px">
                      <span v-if="!transportVolumeValid">{{ t('MSG_00_27') }}</span>
                      <span v-if="formData.isSyncedJWNet && formData.lastTransportVolume == '0.00'">
                        運搬量を0より大きい値で入力してください。
                      </span>
                    </a-row>

                    <a-row :gutter="{ xs: 8, sm: 10 }" class="input-container">
                      <a-col :xs="12" :sm="10" :md="10" :lg="10">
                        <VolumeInput
                          data-jwnet-exempt
                          :status="!valuablesCollectedValid ? 'error' : undefined"
                          v-model:value="formData.lastValuablesCollected"
                          :disabled="
                            viewMode !== VIEWMODE.EDITTING || disableLastValuablesCollected()
                          "
                          :class="
                            authStore.isDischarger &&
                            formData.status === ACHIEVEMENT.STATUS.ACCEPTANCE_OR_DENIAL &&
                            formData.lastValuablesCollected !== formData.valuablesCollected &&
                            AchievementService.convertWeight(formData.lastValuablesCollected) !==
                              formData.valuablesCollected
                              ? 'edited input-right'
                              : 'input-right'
                          "
                        />
                      </a-col>
                      <a-col :xs="12" :sm="12" :md="8" :lg="9" class="field-v-center">
                        <a-select
                          v-model:value="formData.lastValuablesCollectedUnit"
                          style="width: 100%"
                          :disabled="true"
                          :class="
                            authStore.isDischarger &&
                            formData.status === ACHIEVEMENT.STATUS.ACCEPTANCE_OR_DENIAL &&
                            formData.lastValuablesCollectedUnit !== formData.valuablesCollectedUnit
                              ? 'edited'
                              : ''
                          "
                        >
                          <a-select-option
                            v-for="(item, index) in listMeasureUnit"
                            :key="index"
                            :value="item.id"
                          >
                            {{ item.unit }}
                          </a-select-option>
                        </a-select>
                      </a-col>
                    </a-row>
                    <a-row style="color: #ff4d4f; height: 22px; margin-top: -10px">
                      <span v-if="!valuablesCollectedValid">{{ t('MSG_00_27') }}</span>
                    </a-row>

                    <a-row :gutter="{ xs: 8, sm: 10 }" class="input-container">
                      <a-col :xs="20" :sm="24" :md="24" :lg="24">
                        <a-input
                          v-model:value="formData.lastVehicleNumber"
                          :data-jwnet-value="formData.lastVehicleNumber"
                          :disabled="viewMode !== VIEWMODE.EDITTING"
                          maxlength="30"
                          :class="
                            authStore.isDischarger &&
                            formData.status === ACHIEVEMENT.STATUS.ACCEPTANCE_OR_DENIAL &&
                            formData.lastVehicleNumber != formData.vehicleNumber
                              ? 'edited'
                              : ''
                          "
                        />
                      </a-col>
                    </a-row>
                    <a-row style="height: 22px; margin-top: -10px"></a-row>

                    <a-row :gutter="{ xs: 8, sm: 10 }" class="input-container">
                      <a-col :xs="20" :sm="24" :md="24" :lg="24">
                        <a-input
                          v-model:value="formData.lastReporter"
                          :data-jwnet-value="formData.lastReporter"
                          :disabled="viewMode !== VIEWMODE.EDITTING"
                          maxlength="24"
                          :class="
                            authStore.isDischarger &&
                            formData.status === ACHIEVEMENT.STATUS.ACCEPTANCE_OR_DENIAL &&
                            formData.lastReporter != formData.reporter
                              ? 'edited'
                              : ''
                          "
                        />
                      </a-col>
                    </a-row>
                    <a-row style="height: 22px; margin-top: -10px"></a-row>

                    <a-row :gutter="{ xs: 8, sm: 10 }" class="input-container">
                      <a-col :xs="20" :sm="24" :md="24" :lg="24">
                        <a-input
                          v-model:value="formData.lastTransporter"
                          :data-jwnet-value="formData.lastTransporter"
                          :status="!transporterValid ? 'error' : undefined"
                          :disabled="viewMode !== VIEWMODE.EDITTING"
                          maxlength="24"
                          @change="onChangeTransporter"
                          :class="
                            authStore.isDischarger &&
                            formData.status === ACHIEVEMENT.STATUS.ACCEPTANCE_OR_DENIAL &&
                            formData.lastTransporter != formData.transporter
                              ? 'edited'
                              : ''
                          "
                        />
                      </a-col>
                    </a-row>
                    <a-row style="color: #ff4d4f; height: 22px; margin-top: -10px">
                      <span v-if="!transporterValid">{{ t('MSG_00_21') }}</span>
                    </a-row>

                    <a-row :gutter="{ xs: 8, sm: 10 }" class="input-container">
                      <a-col :xs="20" :sm="24" :md="24" :lg="24">
                        <a-select
                          v-model:value="formData.lastDisposalMethodId"
                          style="width: 100%"
                          :disabled="viewMode !== VIEWMODE.EDITTING"
                          show-search
                          :allow-clear="true"
                          :filter-option="searchDisposalMethod"
                          :class="
                            authStore.isDischarger &&
                            formData.status === ACHIEVEMENT.STATUS.ACCEPTANCE_OR_DENIAL &&
                            formData.lastDisposalMethodId != formData.disposalMethodId
                              ? 'edited'
                              : ''
                          "
                        >
                          <a-select-option
                            v-for="(item, index) in listDisposalMethod"
                            :key="item.method"
                            :value="item.id"
                          >
                            <span style="white-space: normal; word-wrap: break-word">{{
                              item.method
                            }}</span>
                          </a-select-option>
                        </a-select>
                      </a-col>
                    </a-row>
                    <a-row style="height: 22px; margin-top: -10px"></a-row>
                  </a-col>
                </a-row>
              </a-col>
            </a-row>
          </template>
        </a-form>
      </a-col>
    </a-row>

    <template #title>
      <a-row>
        <a-col :xs="24" :sm="24" :md="24" :lg="24" class="header">
          <template
            v-if="formData.status === ACHIEVEMENT.STATUS.REJECTION && authStore.isTransporter"
          >
            <span>{{
              $t(
                formData.lastTransportVolume === null
                  ? 'confirm_reject_cancel_report_transportation_industry_waste'
                  : 'confirm_reject_modification_report_transportation_industry_waste'
              )
            }}</span>
          </template>
          <template v-else-if="viewMode === VIEWMODE.REVIEW">
            <span>{{ $t('complete_update_transport_report_title') }}</span>
          </template>
          <template v-else-if="viewMode === VIEWMODE.EDITABLE">
            <span>{{ $t('report_complete_transport_industry_waste') }}</span>
          </template>
          <template v-else-if="viewMode === VIEWMODE.EDITTING">
            <span>{{ $t('fix_transport_report_title') }}</span>
          </template>
          <template v-else-if="viewMode === VIEWMODE.APPROVAL">
            <span>{{ $t('approve_transport_report_title') }}</span>
          </template>
          <template
            v-else-if="
              viewMode === VIEWMODE.READONLY &&
              formData.status === ACHIEVEMENT.STATUS.REQUEST_DELETE
            "
          >
            <span>{{ $t('cancel_report_completion_transport_industry_waste') }}</span>
          </template>
          <template v-else>
            <span>{{ $t('report_complete_transport_industry_waste') }}</span>
          </template>
        </a-col>
      </a-row>
    </template>

    <template #footer>
      <div class="footer">
        <template v-if="viewMode === VIEWMODE.EDITABLE">
          <a-button
            type="primary"
            @click="cancelReport"
            :disabled="isDisabledBtn()"
            :class="isDisabledBtn() ? 'danger-btn-disabled' : 'danger-btn'"
          >
            {{ $t('cancel_report') }}
          </a-button>
          <a-button type="primary" @click="changeToFix" :disabled="isDisabledBtn()">{{
            $t('fix_report')
          }}</a-button>
        </template>
        <template v-else-if="viewMode === VIEWMODE.EDITTING">
          <a-button type="primary" @click="fixReport" :disabled="isDisabledBtnFixReport()">{{
            $t('fix_it')
          }}</a-button>
        </template>
        <template v-else-if="viewMode === VIEWMODE.APPROVAL">
          <a-button
            type="primary"
            @click="reject"
            :disabled="isDisabledBtn()"
            :class="isDisabledBtn() ? 'danger-btn-disabled' : 'danger-btn'"
          >
            {{ $t('reject') }}
          </a-button>
          <a-button type="primary" @click="approve" :disabled="isDisabledBtn()">{{
            $t('approve')
          }}</a-button>
        </template>
        <template
          v-else-if="
            viewMode === VIEWMODE.READONLY &&
            formData.status === ACHIEVEMENT.STATUS.REQUEST_DELETE &&
            !authStore.isTransporter
          "
        >
          <a-button
            type="primary"
            @click="reject"
            :disabled="isDisabledBtn()"
            :class="isDisabledBtn() ? 'danger-btn-disabled' : 'danger-btn'"
          >
            {{ $t('reject') }}
          </a-button>
          <a-button
            type="primary"
            @click="approve"
            :disabled="authStore.isTransporter || isDisabledBtn()"
            >{{ $t('approve') }}</a-button
          >
        </template>
        <template
          v-else-if="formData.status === ACHIEVEMENT.STATUS.REJECTION && authStore.isTransporter"
        >
          <a-button type="primary" @click="correctReport">{{ $t('confirm_rejection') }}</a-button>
        </template>
        <template v-else>
          <div></div>
        </template>
      </div>
      <template v-if="formData.isSyncedJWNet && !isJWNetEnable()">
        <div class="jwnet-notice">
          JWNETとの連携時間は 7:00～19:00
          です。運搬終了報告の修正・取消、修正・取消に対しての認否は、連携時間内に実行願います。
        </div>
      </template>
      <template v-if="isDisabledBtnWhenJWNetRunning()">
        <div class="jwnet-notice">
          <span>{{ $t('MSG_21_9') }}</span>
        </div>
      </template>
      <template v-if="!formData.isJWNetApiAvailable">
        <div class="jwnet-notice">
          JWNETサービス停止日
          です。運搬終了報告の修正・取消、修正・取消に対しての認否は、サービス停止日を確認の上、後日実行願います。
        </div>
      </template>
    </template>
  </a-modal>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { message, Modal } from 'ant-design-vue';
import { useI18n } from 'vue-i18n';
import { useAuthStore } from '@/stores';
import { ACHIEVEMENT } from '@/constants';
import dayjs, { Dayjs } from 'dayjs';
import InputSlot from '../components/InputSlot.vue';
import AchievementService from '@/services/modules/AchievementService';
import { formatModalTitle } from '@/utils/modules/message';
import VolumeInput from './VolumeInput.vue';
import { useJwnetValidation } from '@/utils/useJwnetValidation';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  id: {
    type: Number,
    default: null
  }
});

const VIEWMODE = {
  READONLY: 1,
  REVIEW: 2,
  EDITABLE: 3,
  EDITTING: 4,
  APPROVAL: 5
};

const emit = defineEmits(['close', 'update', 'delete']);

const { t } = useI18n();
const authStore = useAuthStore();
const viewMode = ref<number>(0);
const formRef = ref();
const { finishValidation, clearErrors } = useJwnetValidation(formRef);
const endDateTransportNew = ref();
const endDateTransportValid = ref();
const transportVolumeValid = ref();
const valuablesCollectedValid = ref();
const transporterValid = ref();
const listMeasureUnit = ref<any[]>([]);
const listDisposalMethod = ref<any[]>([]);

watch(
  () => props.visible,
  async (val) => {
    clearErrors();
    if (val) {
      listMeasureUnit.value = await AchievementService.getListMeasureUnit();
      listDisposalMethod.value = await AchievementService.getListDisposalMethod();
      formData.value = await AchievementService.getAchievementWasteIndustryDetail(props.id);
      if (formData.value?.transportVolume != null) {
        formData.value.transportVolume = AchievementService.convertWeight(
          formData.value.transportVolume
        );
      }
      if (formData.value?.valuablesCollected != null) {
        formData.value.valuablesCollected = AchievementService.convertWeight(
          formData.value.valuablesCollected
        );
      }
      if (formData.value?.lastTransportVolume != null) {
        formData.value.lastTransportVolume = AchievementService.convertWeight(
          formData.value.lastTransportVolume
        );
      }
      if (formData.value?.lastValuablesCollected != null) {
        formData.value.lastValuablesCollected = AchievementService.convertWeight(
          formData.value.lastValuablesCollected
        );
      }
      endDateTransportNew.value = undefined;
      endDateTransportValid.value = true;
      transportVolumeValid.value = true;
      valuablesCollectedValid.value = true;
      transporterValid.value = true;
      if (authStore.isTransporter) {
        if (formData.value.status === ACHIEVEMENT.STATUS.ACCEPTANCE_OR_DENIAL) {
          viewMode.value = VIEWMODE.REVIEW;
        } else if (formData.value.status === ACHIEVEMENT.STATUS.REQUEST_DELETE) {
          viewMode.value = VIEWMODE.READONLY;
        } else if (formData.value.status === ACHIEVEMENT.STATUS.REJECTION) {
          viewMode.value =
            formData.value.lastEndDateTransport == null &&
            formData.value.lastTransportVolume == null &&
            formData.value.lastTransporter == null
              ? VIEWMODE.READONLY
              : VIEWMODE.REVIEW;
        } else {
          viewMode.value = VIEWMODE.EDITABLE;
          formData.value.lastEndDateTransport = '';
          formData.value.lastVehicleNumber = '';
          formData.value.lastTransportVolume = '';
          formData.value.lastValuablesCollected = '';
          formData.value.lastReporter = '';
          formData.value.lastTransporter = '';
        }
      } else {
        if (formData.value.status === ACHIEVEMENT.STATUS.ACCEPTANCE_OR_DENIAL) {
          viewMode.value = VIEWMODE.APPROVAL;
        } else if (formData.value.status === ACHIEVEMENT.STATUS.REJECTION) {
          viewMode.value =
            formData.value.lastEndDateTransport == null &&
            formData.value.lastTransportVolume == null &&
            formData.value.lastTransporter == null
              ? VIEWMODE.READONLY
              : VIEWMODE.REVIEW;
        } else {
          viewMode.value = VIEWMODE.READONLY;
        }
      }
    }
  }
);

const formData = ref<any>({
  projectTitle: '',
  collectTime: '',
  wasteName: '',
  manifestId: '',
  endDateTransport: '',
  lastEndDateTransport: '',
  vehicleNumber: '',
  lastVehicleNumber: '',
  transportVolume: '',
  lastTransportVolume: '',
  valuablesCollected: '',
  lastValuablesCollected: '',
  reporter: '',
  lastReporter: '',
  transporter: '',
  lastTransporter: '',
  status: ''
});

const closePopup = () => {
  clearErrors();
  emit('close');
  formData.value = {
    projectTitle: '',
    collectTime: '',
    wasteName: '',
    manifestId: '',
    endDateTransport: '',
    lastEndDateTransport: '',
    vehicleNumber: '',
    lastVehicleNumber: '',
    transportVolume: '',
    lastTransportVolume: '',
    valuablesCollected: '',
    lastValuablesCollected: '',
    reporter: '',
    lastReporter: '',
    transporter: '',
    lastTransporter: '',
    status: ''
  };
  endDateTransportNew.value = undefined;
};

const cancelReport = () => {
  let modal = Modal.confirm({
    title: '',
    cancelText: t('yes'),
    cancelButtonProps: {
      type: 'primary',
      onClick: async () => {
        await AchievementService.deleteAchievementIndustry(props.id)
          .then(() => {
            let content = '';
            if (formData.value.isSyncedJWNet) {
              content = t('MSG_21_9');
            } else {
              content = t('message_delete_report_transport_industry_waste_success');
              emit('update');
            }
            message.success({
              content: content,
              duration: 5
            });
            closePopup();
          })
          .catch(() => {
            message.error({
              content: t('message_delete_report_transport_industry_waste_fail'),
              duration: 5
            });
          });
        modal.destroy();
      }
    },
    okText: t('no'),
    okType: 'danger',
    centered: true,
    maskClosable: true,
    onOk() {
      modal.destroy();
    }
  });
  const title = t('MSG_21_2');
  modal.update({
    title: formatModalTitle(title)
  });
};

const getUnitName = (unit: number) => {
  let result = listMeasureUnit.value.find((item) => item.id === unit);
  return result != undefined ? result.unit : '';
};

const onChangeTransportEndDate = (date: Dayjs, dateString: string) => {
  formData.value.lastEndDateTransport = dateString;
  endDateTransportValid.value =
    formData.value.lastEndDateTransport !== undefined && formData.value.lastEndDateTransport !== '';
};

const onChangeTransporter = () => {
  transporterValid.value =
    formData.value.lastTransporter !== undefined && formData.value.lastTransporter !== '';
};

const disableCollectionDate = (day: Dayjs) => {
  if (formData.value.collectTime === null) {
    return false;
  }
  if (!formData.value.collectTime.includes(t('wave_dash_character'))) {
    return day.isBefore(dayjs(formData.value.collectTime, 'YYYY-MM-DD').startOf('day'));
  }
  let times = formData.value.collectTime.split(t('wave_dash_character'));
  let endDate = dayjs(times[1].trim(), 'YYYY-MM-DD HH:mm');
  let createdAt = dayjs(formData.value.createdAt);
  return day.isBefore(endDate.startOf('day')) || day.isAfter(createdAt.endOf('day'));
};

const changeToFix = () => {
  clearErrors();
  viewMode.value = VIEWMODE.EDITTING;
  endDateTransportNew.value = dayjs(formData.value.endDateTransport, 'YYYY/MM/DD');
  formData.value.endDateTransportNew = formData.value.endDateTransport;
  formData.value.lastEndDateTransport = formData.value.endDateTransport;
  formData.value.lastVehicleNumber = formData.value.vehicleNumber;
  formData.value.lastTransportVolume = formData.value.transportVolume;
  formData.value.lastValuablesCollected = formData.value.valuablesCollected;
  formData.value.valuablesCollected = formData.value.lastValuablesCollected;
  formData.value.lastTransportVolumeUnit = formData.value.transportVolumeUnit;
  formData.value.lastValuablesCollectedUnit = formData.value.valuablesCollectedUnit;
  formData.value.lastReporter = formData.value.reporter;
  formData.value.lastTransporter = formData.value.transporter;
  formData.value.lastDisposalMethodId = formData.value.disposalMethodId;
};

const fixReport = async () => {
  endDateTransportValid.value = formData.value.endDateTransportNew != undefined;
  const regex = /^\d{1,5}(\.\d{0,2})?$/;
  transportVolumeValid.value =
    !!formData.value.lastTransportVolume &&
    formData.value.lastTransportVolume != '0' &&
    regex.test(formData.value.lastTransportVolume.replace(/,/g, ''));
  valuablesCollectedValid.value =
    !formData.value.lastValuablesCollected ||
    regex.test(formData.value.lastValuablesCollected.replace(/,/g, ''));
  transporterValid.value =
    formData.value.lastTransporter != undefined && formData.value.lastTransporter != '';
  if (
    !(await finishValidation(
      endDateTransportValid.value &&
        transportVolumeValid.value &&
        valuablesCollectedValid.value &&
        transporterValid.value
    ))
  )
    return;
  if (formData.value.transportVolume != null) {
    formData.value.transportVolume = formData.value.transportVolume.replace(/,/g, '');
  }
  if (formData.value.valuablesCollected != null) {
    formData.value.valuablesCollected = formData.value.valuablesCollected.replace(/,/g, '');
  }
  if (formData.value.lastTransportVolume != null) {
    formData.value.lastTransportVolume = formData.value.lastTransportVolume.replace(/,/g, '');
  }
  if (formData.value.lastValuablesCollected != null) {
    formData.value.lastValuablesCollected = formData.value.lastValuablesCollected.replace(/,/g, '');
  }
  let modal = Modal.confirm({
    title: '',
    cancelText: t('yes'),
    cancelButtonProps: {
      type: 'primary',
      onClick: async () => {
        await AchievementService.updateAchievementIndustry(formData.value)
          .then((data: any) => {
            let content = '';
            if (formData.value.isSyncedJWNet) {
              content = t('MSG_21_9');
            } else {
              content = t('message_update_report_transport_industry_waste_success');
              emit('update');
            }
            message.success({
              content: content,
              duration: 5
            });
            closePopup();
          })
          .catch(() => {
            message.error({
              content: t('message_update_report_transport_industry_waste_fail'),
              duration: 5
            });
          });
        modal.destroy();
      }
    },
    okText: t('no'),
    okType: 'danger',
    centered: true,
    maskClosable: true,
    onOk() {
      modal.destroy();
    }
  });
  const title = t('MSG_21_1');
  modal.update({
    title: formatModalTitle(title)
  });
};

const reject = () => {
  let modal = Modal.confirm({
    title: '',
    cancelText: t('yes'),
    cancelButtonProps: {
      type: 'primary',
      onClick: async () => {
        await updateAchievementIndustryStatus(ACHIEVEMENT.STATUS.REJECTION)
          .then((data) => {
            message.success({
              content: t('MSG_21_9'),
              duration: 5
            });
            closePopup();
          })
          .catch(() => {
            message.error({
              content: t('message_update_report_transport_industry_waste_fail'),
              duration: 5
            });
          });
        modal.destroy();
      }
    },
    okText: t('no'),
    okType: 'danger',
    centered: true,
    maskClosable: true,
    onOk() {
      modal.destroy();
    }
  });
  const title =
    formData.value.status === ACHIEVEMENT.STATUS.REQUEST_DELETE
      ? formatModalTitle(t('MSG_21_5'))
      : formatModalTitle(t('MSG_21_3'));
  modal.update({
    title: title
  });
};

const approve = () => {
  let modal = Modal.confirm({
    title: '',
    cancelText: t('yes'),
    cancelButtonProps: {
      type: 'primary',
      onClick: async () => {
        await updateAchievementIndustryStatus(ACHIEVEMENT.STATUS.BLANK)
          .then((data) => {
            message.success({
              content: t('MSG_21_9'),
              duration: 5
            });
            closePopup();
          })
          .catch(() => {
            message.error({
              content: t('message_update_report_transport_industry_waste_fail'),
              duration: 5
            });
          });
        modal.destroy();
      }
    },
    okText: t('no'),
    okType: 'danger',
    centered: true,
    maskClosable: true,
    onOk() {
      modal.destroy();
    }
  });
  const title =
    formData.value.status === ACHIEVEMENT.STATUS.REQUEST_DELETE
      ? formatModalTitle(t('MSG_21_6'))
      : formatModalTitle(t('MSG_21_4'));
  modal.update({
    title: title
  });
};

const correctReport = () => {
  let modal = Modal.confirm({
    title: '',
    cancelText: t('yes'),
    cancelButtonProps: {
      type: 'primary',
      onClick: async () => {
        await updateAchievementIndustryStatus(ACHIEVEMENT.STATUS.BLANK);
        emit('update');
        closePopup();
        modal.destroy();
      }
    },
    okText: t('no'),
    okType: 'danger',
    centered: true,
    maskClosable: true,
    onOk() {
      modal.destroy();
    }
  });
  const title = t('MSG_21_7');
  modal.update({
    title: formatModalTitle(title)
  });
};

const updateAchievementIndustryStatus = async (status: string) => {
  await AchievementService.updateAchievementIndustryStatus(props.id, status);
};

const getModalWidth = () => {
  if (
    viewMode.value === VIEWMODE.REVIEW ||
    viewMode.value === VIEWMODE.EDITTING ||
    viewMode.value === VIEWMODE.APPROVAL
  ) {
    return '900px';
  }
  return '600px';
};

const getDisposalMethodName = (id: any) => {
  let result = listDisposalMethod.value.find((item) => item.id === id);
  return result != undefined ? result.method : '';
};

const searchDisposalMethod = (value: string, option: any, record: any) => {
  return option.key.toLowerCase().includes(value.toLowerCase());
};

const isJWNetEnable = (): boolean => {
  let currentTimeJp = AchievementService.getCurrentTimeInJapan();
  let currentTimeSecond = AchievementService.calculateTotalSecond(currentTimeJp);
  let startTimeSecond = AchievementService.calculateTotalSecond(ACHIEVEMENT.JWNET.START_TIME);
  let endTimeSecond = AchievementService.calculateTotalSecond(ACHIEVEMENT.JWNET.END_TIME);
  return startTimeSecond <= currentTimeSecond && currentTimeSecond <= endTimeSecond;
};

const isDisabledBtn = (): boolean => {
  return (
    (formData.value.isSyncedJWNet && !isJWNetEnable()) ||
    formData.value.manifestId == null ||
    isDisabledBtnWhenJWNetRunning() ||
    !formData.value.isJWNetApiAvailable
  );
};

const isDisabledBtnFixReport = (): boolean => {
  return (
    formData.value.isSyncedJWNet &&
    (!isJWNetEnable() ||
      isDisabledBtnWhenJWNetRunning() ||
      formData.value.lastTransportVolume == '' ||
      formData.value.lastTransportVolume == '0.00')
  );
};

const isDisabledBtnWhenJWNetRunning = (): boolean => {
  if (formData.value.runningFunctions == null || formData.value.runningFunctions.length == 0) {
    return false;
  }
  if (formData.value.manifestStatus != 'TEMP_TRANSPORT') {
    return true;
  }
  return (
    formData.value.runningFunctions.includes('1000') ||
    formData.value.runningFunctions.includes('0403')
  );
};

const disableLastValuablesCollected = () => {
  if (formData.value.lastValuablesCollectedUnit != null) {
    let unit = listMeasureUnit.value.find(
      (item) => item.id === formData.value.lastValuablesCollectedUnit
    );
    return unit?.unit === '個・台';
  }
};

const getCollectTimeLabel = (collectionTime: string) => {
  return collectionTime.includes(t('wave_dash_character'))
    ? collectionTime
    : collectionTime + '（終日）';
};

watch(
  () => formData.value.lastTransportVolume,
  (val) => {
    transportVolumeValid.value =
      formData.value.lastTransportVolume !== null &&
      formData.value.lastTransportVolume !== '' &&
      formData.value.lastTransportVolume !== '0';
  }
);

watch(
  () => formData.value.lastValuablesCollected,
  (val) => {
    valuablesCollectedValid.value = AchievementService.validateVolume(
      formData.value.lastValuablesCollected
    );
  }
);
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.header {
  text-align: center;
  color: #0083e9;
  font-size: 20px;
  border-bottom: 1px solid $gray-color;
  padding-bottom: 10px;
  margin-bottom: 10px;
}

.input-container {
  margin-bottom: 10px;

  .edited {
    border-color: #fe8d8d;
    background-color: #feeeee;
    box-shadow: none;
  }

  .edited:focus {
    border-color: #fe8d8d;
    box-shadow: none;
  }
}

.header-row {
  margin-bottom: 10px;
  height: 32px;
  align-content: center;
}

.modal-content {
  margin-right: -60px;
}

.field-v-center {
  align-content: center;
}

.left {
  float: left;
}

.margin-left-3 {
  margin-left: 3px;
}

.height-32 {
  height: 32px;
}

.long-input {
  width: calc(100% - 60px);
}

.sub-input {
  margin-left: -4px;
}

.volume-view {
  width: 72px;
  display: inline-block;
  text-align: right;
}

.separate-area {
  display: flex;
  justify-content: center;
  align-items: center;

  .arrow-container {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #ffefef;
    padding-left: 5px;
    padding-right: 5px;

    .arrow {
      display: inline-block;
      width: 20px;
      height: 12px;
      background: #fe0000;
      clip-path: polygon(0 29.2%, 48% 29.2%, 48% 0, 100% 50%, 48% 100%, 48% 70.8%, 0 70.8%);
    }
  }
}

input.input-right {
  text-align: right;
}

.align-right {
  text-align: right;
}

.jwnet-notice {
  text-align: center;
  margin-top: 10px;
  color: $red-color;
}

.required-area {
  width: 40px;
  float: right;
  text-align: right;

  .required-label {
    background-color: $red-color;
    color: white;
    padding: 3px 5px;
    border-radius: 3px;
    font-size: 11px;
  }
}

@media (max-width: 574px) {
  .required-area {
    float: left;
  }
}

.footer {
  text-align: center;
  border-top: 1px solid $gray-color;
  padding-top: 20px;

  button {
    background-color: $blue-color;
    width: 140px;
  }

  .danger-btn {
    background-color: $red-color;
  }

  .danger-btn:hover {
    background-color: #ffa2a2;
    color: #ffffff;
  }

  .danger-btn-disabled {
    background-color: #ffa2a2;
    color: #ffffff;
  }
}

@media (max-width: 576px) {
  .arrow-container {
    background-color: initial;
    margin-bottom: 10px;
    width: calc(100% - 60px);
    margin-left: -60px;
    padding-top: 3px;
    padding-bottom: 3px;

    .arrow {
      height: 100%;
      transform: rotate(90deg);
    }
  }
}

@media (max-width: 367px) {
  .footer {
    display: flex;
  }
}

:deep(span.input-right input) {
  text-align: right;
}

:deep(.input-container .edited .ant-select-selector) {
  border-color: #fe8d8d;
  background-color: #feeeee;
  box-shadow: none;
}
</style>
